import React, { useEffect, useMemo, useReducer } from 'react';
import Context from './Context';
import { useMediaQuery } from '@mui/material';

import { setIsMenuOpen } from './store/actions';
import reducer from './store/reducer';
import initalValue from './store/inital';

const Provider = ({ children }) => {
  // const savedState = JSON.parse(localStorage.getItem(persistKey));

  const [store, dispatch] = useReducer(reducer, initalValue);
  const { isMenuOpen } = store;
  const props = useMemo(
    () => ({
      //setter
      toggleThis(value, newValue = null) {
        if (value === 'isMenuOpen') {
          dispatch(setIsMenuOpen(newValue !== null ? newValue : !isMenuOpen));
        }
      },
      //getters
      isMenuOpen,
    }),
    [store],
  );
  const isDesktop = useMediaQuery('(min-width:600px)');

  // useEffect(() => {
  //   try {
  //     localStorage.setItem(persistKey, JSON.stringify(store));
  //   } catch (error) {
  //     console.warn(error);
  //   }
  // }, [store, persistKey]);

  useEffect(() => {}, [isDesktop, props]);

  return (
    <Context.Provider
      value={{
        isDesktop,
        ...props,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Provider;
